"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ImportProgressProps {
  currentRow: number;
  totalRows: number;
}

/**
 * Progress display component during CSV import
 */
export function ImportProgress({ currentRow, totalRows }: ImportProgressProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Importing Items...</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <span>Progress:</span>
            <span>
              {currentRow} of {totalRows}
            </span>
          </div>
          <div className="w-full bg-card-200 rounded-full h-2">
            <div
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${(currentRow / totalRows) * 100}%` }}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
